import { useController, useFormContext } from 'react-hook-form'
import { GoPay } from '@sga/shopify-payments-types'

import { Card, Select, SelectOption } from '@shopify/polaris'

import { useAccount } from '../hooks/useAccount'
import { getTranslation } from '../util/getTranslation'

export function SettingsLanguage({ languages }: { languages: SelectOption[] }) {
  const account = useAccount<GoPay.TSegmentAccount>()
  const { setValue } = useFormContext()
  const { field } = useController({
    name: 'language',
    defaultValue: account.segmentConfig.language || '',
  })

  return (
    <Card.Section>
      <Select
        helpText={getTranslation('settings.language_help')}
        label={getTranslation('settings.preferred_gateway_language')}
        value={field.value}
        options={languages}
        onChange={(selected) => {
          setValue(field.name, selected, {
            shouldDirty: true,
            shouldTouch: true,
          })
        }}
      />
    </Card.Section>
  )
}
